import Axios from 'axios';
import { userService } from './user.service'; // Importa el userService para obtener el token


const BASE_URL = process.env.NODE_ENV === 'production'
    ? 'https://planificacionapi.cderl.com/'
    : 'https://planificacionapi.cderl.com/'


var axios = Axios.create({
    withCredentials: true
});

export const httpService = {
    get(endpoint, data) {
        return ajax(endpoint, 'GET', data);
    },
    post(endpoint, data) {
        return ajax(endpoint, 'POST', data);
    },
    put(endpoint, data) {
        return ajax(endpoint, 'PUT', data);
    },
    delete(endpoint, data) {
        return ajax(endpoint, 'DELETE', data);
    }
};

async function ajax(endpoint, method = 'GET', data = null) {
    
    let token = null; // Obtén el token del usuario logueado
    if(endpoint !== "loginuser/login"){
        token = userService.getLoggedinUser()?.token; // Obtén el token del usuario logueado
    }
    try {
        const res = await axios({
            url: `${BASE_URL}${endpoint}`,
            method,
            data,
            headers: {
                Authorization: token // Envía solo el token en el encabezado de autorización
            }
        });

        return res.data;
    } catch (err) {
        console.error(`Error en ${method} ${endpoint}`, err);
        if (err.response && err.response.status === 401) {
            userService.redirectToLogin(); // Redirigir al login en caso de error 401
        }
        throw err;
    }
}




export default httpService;
